import { IHeroSlide } from '$root/src/components';
import cn from 'classnames';
import { HTMLAttributes } from 'react';

export function Leader(props: IHeroSlide & HTMLAttributes<HTMLElement>) {
  const { caption } = props;

  if (caption !== null && caption.trim() !== '') {
    return (
      <div className={cn('relative mb-2 lg:mb-4 pl-[5px]')}>
        <h5
          className={cn(
            'style-heading-xxxs text-grey-80 dark:text-white mb-4 lg:mb-6',
          )}
        >
          {caption}
        </h5>
        <div
          className={cn(
            'w-[128px] border-t-[1px] border-grey-80 dark:border-white',
          )}
        ></div>
      </div>
    );
  } else {
    return null;
  }
}
